module.exports = __webpack_public_path__ + "static/image/sign/kimbeomjun@3x.png?0d766d74";